export const administrationAccountsSiteLocationRsc = {
    template: require('./administration-accounts-site-location-rsc.html'),
    controller: 'AdministrationAccountsSiteLocationRscController'
};
